import { useDispatch, useSelector } from 'react-redux';
import camelCase from 'camelcase';

import { Selectors, Async } from 'modules/Dashboard/Widgets/WidgetsSlice';

export const useCompletionRate = ({ widgetType }) => {
  const widgetsState = useSelector(Selectors.fetchListData);

  const dispatch = useDispatch();

  const fetchCompletionRate = (intervalOption = '7') => {
    dispatch(
      Async.fetchCompletionRate({
        widget_type: widgetType,
        filters: {
          days: +intervalOption,
        },
      })
    );
  };

  return {
    fetchCompletionRate,
    completionRate: widgetsState[camelCase(widgetType)],
  };
};
